export default __webpack_public_path__ + "static/media/notepad_check.afa1aaa4.svg";